import OccurrenceCreate from './occurrence_create.coffee'
import ImageUploadBase from './image_upload_base'
import CountFieldCharacters from './count_field_characters'
import OccurrenceFileUploadBase from './document_upload_base'
import { set_description_with_suggested, set_description_with_suggested_page_render } from './helpers'

$(document).on('turbolinks:load', function () {
  new CountFieldCharacters().handler_events();
  new OccurrenceCreate().handler_events();

  new OccurrenceFileUploadBase(
    ".js-occurrence-photos-dropzone",
    '.js-dropzone-preview-container-occurrence',
    '.js-dropzone-document-preview-container-occurrence',
    '#js-upload-button-occurrence',
    '#js-dropzone-preview-template-occurrence',
    'occurrence[files][]'
  ).call()

  new OccurrenceFileUploadBase(
    ".js-occurrence-action-photos-dropzone",
    '.js-dropzone-preview-container-action',
    '.js-dropzone-document-preview-container-action',
    '#js-upload-button-action',
    '#js-dropzone-preview-template-occurrence',
    'occurrence_action[files][]'
  ).call()

  set_description_with_suggested_page_render();

  $(document).on('change', '#js_occurrence_type_id', function () {

    const $selected = $('option:selected', this);
    const suggested_description = $selected.attr('data-suggested_description');
    const description_input = $('#js_occurrence_description');

    set_description_with_suggested(suggested_description, description_input);
  });
})
